/** Monitoring and alerts — English, the source of the other languages */
const monitoring = {
  "monitoring.subtitle": "Real-time status across all sites",
  "monitoring.online": "Online",
  "monitoring.warning": "Warning",
  "monitoring.offline": "Offline",
  "monitoring.awaitingVpn": "Awaiting VPN",
  "monitoring.noData": "No data",
  "monitoring.lastSeen": "Last seen {when}",
  "monitoring.alertsActive": { one: "{count} active alert", other: "{count} active alerts" },
  "monitoring.alertsResolved": { one: "{count} resolved alert", other: "{count} resolved alerts" },
  "monitoring.active": "Active",
  "monitoring.resolved": "Resolved",
  "monitoring.noResolved": "No resolved alerts",
  "monitoring.allClear": "All clear!",
  "monitoring.noneResolvedYet": "No alerts have been resolved yet.",
  "monitoring.healthy": "No active alerts — your network is healthy.",
  "monitoring.acknowledge": "Acknowledge",
  "monitoring.acknowledged": "✓ Acknowledged",
  "monitoring.resolvedWhen": "✓ Resolved {when}",
  "monitoring.category.VPN": "VPN",
  "monitoring.category.cellular": "cellular",
  "monitoring.category.device": "device",
  "monitoring.category.firmware": "firmware",
  "monitoring.category.license": "licence",
  "monitoring.category.link": "link",
  "monitoring.category.speedfusion": "speedfusion",
  "monitoring.category.sync": "sync",
  "monitoring.category.wan": "wan",
  "monitoring.category.wifi": "wifi",
}

export default monitoring
